import React from 'react';
import { Button, FormGroup, Input } from '@punchcard/core';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';

interface IProps {
	handleWorkbookSave: () => void;
}
const WorkbookCompletion = (props: IProps) => {

	const { t } = useTranslation();

	const methods = useFormContext<WIPForm>();
	const { control } = methods;
	const gradeValue = methods.watch('completionGradeValue');

	function renderPage() {

		return (
			<React.Fragment>
				<div className="d-flex flex-column flex-grow-1 overflow-hidden bg-white p-4">
					<h3>{t('wip.workbook_completion')}</h3>
					<p style={{ whiteSpace: 'pre-wrap' }}>{t('wip.workbook_description')}</p>

					<div className="overflow-y-auto flex-grow-1" style={{ maxWidth: '420px' }}>
						<Controller
							control={control}
							name="gradeReceived"
							rules={{
								required: t('this_field_is_required'), // Required validation
								validate: {
									maxGrade: (value) =>
										(value ?? 0) <= (gradeValue ?? 0)
										|| t('exam.grade_must_be_less_than_or_equal_to',
											{ count: gradeValue }), // Custom validation for max value
								},
							}}
							render={({ field, fieldState }) =>
								<FormGroup label={t('wip.workbook_completion_grade')} required={true} fieldState={fieldState}>
									<Input
										append={`/ ${gradeValue?.toString()}`}
										{...field}
										error={!!fieldState.error?.message}
									/>
								</FormGroup>
							}
						/>
					</div>



				</div >
				<div className="mb-3">
					<Button
						onClick={methods.handleSubmit(props.handleWorkbookSave)}
						className="btn btn-primary mt-3 ms-3"
					>
						{t('wip.submit')}
					</Button>
				</div>
			</React.Fragment>

		);

	}


	return (
		<React.Fragment>
			<div className="d-flex align-items-center bg-quaternary-400 rounded-top-3 pe-0" style={{ minHeight: 55 }}></div>
			{renderPage()}
		</React.Fragment>
	);
};

export default WorkbookCompletion;